import Typography from '@mui/material/Typography';
import { TabPanel } from '@mui/lab';
import Box from '@mui/material/Box';
import { Input } from '../../../../../shared/components/Input';
import { InputCNPJCPF } from '../../../../../shared/components/InputCNPJ';
import Divider from '@mui/material/Divider';
import { InputTelephone } from '../../../../../shared/components/InputTelephone';
import { InputCEP } from '../../../../../shared/components/InputCEP';


export const TabDestinario = ({ values } : { values: any }) => {
  return (
    <TabPanel value='3'>
      <Box className='grid grid-cols-8 gap-7 pt-4'>
        <Typography className='col-span-8' variant='h6'>
          Dados Destinatário
        </Typography>
        <Input
          disabled={true}
          label='Razão Social'
          className='col-span-4'
          name='usu_nome'
          value={values?.nfeProc?.NFe?.infNFe?.dest?.xNome}
        />
        <Box className={'col-span-4'} />
        <InputCNPJCPF
          disabled={true}
          label='CNPJ'
          className='col-span-2'
          name='usu_nome'
          value={values?.nfeProc?.NFe?.infNFe?.dest?.CNPJ}
        />
        <InputCNPJCPF
          disabled={true}
          label='CPF'
          className='col-span-2'
          name='usu_nome'
          value={values?.nfeProc?.NFe?.infNFe?.dest?.CPF}
        />
        <Input
          disabled={true}
          label='Inscrição Estadual'
          className='col-span-2'
          name='usu_nome'
          value={values?.nfeProc?.NFe?.infNFe?.dest?.IE}
        />
        <Input
          disabled={true}
          label='Inscrição Estadual ST'
          className='col-span-2'
          name='usu_nome'
          value={''}
        />
        <Input
          disabled={true}
          label='Regime Tributário:'
          className='col-span-4'
          name='usu_nome'
          value={''}
        />
        <Input
          disabled={true}
          label='Inscrição Municipal'
          className='col-span-2'
          name='usu_nome'
          value={values?.nfeProc?.NFe?.infNFe?.dest?.IM}
        />
        <Input
          disabled={true}
          label='CNAE'
          className='col-span-2'
          name='usu_nome'
          value={values?.nfeProc?.NFe?.infNFe?.dest?.CNAE}
        />
        <Divider className='col-span-8' />
        <Typography className='col-span-8' variant='h6'>
          Dados Contato
        </Typography>
        <InputTelephone
          disabled={true}
          label='Telefone'
          className='col-span-2'
          name='usu_nome'
          value={values?.nfeProc?.NFe?.infNFe?.dest?.enderDest?.fone}
        />
        <InputCEP
          disabled={true}
          label='CEP'
          className='col-span-2'
          name='usu_nome'
          value={values?.nfeProc?.NFe?.infNFe?.dest?.enderDest?.CEP}
        />
        <Input
          disabled={true}
          label='Logradouro'
          className='col-span-4'
          name='usu_nome'
          value={values?.nfeProc?.NFe?.infNFe?.dest?.enderDest?.xLgr}
        />
        <Input
          disabled={true}
          label='Número'
          className='col-span-2'
          name='usu_nome'
          value={values?.nfeProc?.NFe?.infNFe?.dest?.enderDest?.nro}
        />
        <Input
          disabled={true}
          label='Complemento'
          className='col-span-2'
          name='usu_nome'
          value={values?.nfeProc?.NFe?.infNFe?.dest?.enderDest?.cmp}
        />
        <Input
          disabled={true}
          label='Bairro'
          className='col-span-4'
          name='usu_nome'
          value={values?.nfeProc?.NFe?.infNFe?.dest?.enderDest?.xBairro}
        />
        <Input
          disabled={true}
          label='Código Municipio'
          className='col-span-2'
          name='usu_nome'
          value={values?.nfeProc?.NFe?.infNFe?.dest?.enderDest?.cMun}
        />
        <Input
          disabled={true}
          label='Municipio'
          className='col-span-4'
          name='usu_nome'
          value={values?.nfeProc?.NFe?.infNFe?.dest?.enderDest?.xMun}
        />
        <Input
          disabled={true}
          label='Unidade Federativa'
          className='col-span-2'
          name='usu_nome'
          value={values?.nfeProc?.NFe?.infNFe?.dest?.enderDest?.UF}
        />
        <Input
          disabled={true}
          label='Código Pais'
          className='col-span-2'
          name='usu_nome'
          value={values?.nfeProc?.NFe?.infNFe?.dest?.enderDest?.cPais}
        />
        <Input
          disabled={true}
          label='Pais'
          className='col-span-2'
          name='usu_nome'
          value={values?.nfeProc?.NFe?.infNFe?.dest?.enderDest?.xPais}
        />
      </Box>
    </TabPanel>
  )
}